import React, { useState } from 'react';
import { getYoutubeThumbnailUrl } from '../utils/videoLinks';

interface ContentThumbnailProps {
  imageUrl?: string | null;
  videoUrlYoutube?: string | null;
  contentType?: string;
  title?: string;
  className?: string;
}

// 没有封面图、也取不到视频缩略图时的固定兜底图（公司 logo + 网址），放在 public/ 下，
// 不用组件库/图标库拼凑占位样式，直接用统一的品牌图。
const FALLBACK_THUMBNAIL = '/content-placeholder.png';

/**
 * 资源中心列表卡片的缩略图：
 * 1) 有封面图（image_url）就直接用；
 * 2) 没有封面图、但是视频类内容挂了 YouTube 链接，就用 YouTube 官方的静态缩略图兜底
 *    （不需要额外上传截图，也不用调用任何接口）；
 * 3) 上面两个都没有：显示固定的品牌占位图（公司 logo + 网址），不再是一个孤零零的
 *    灰底文字块，看起来是故意的设计而不是漏传了图。
 */
const ContentThumbnail: React.FC<ContentThumbnailProps> = ({ imageUrl, videoUrlYoutube, title, className }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const effectiveSrc = !imgFailed ? imageUrl || getYoutubeThumbnailUrl(videoUrlYoutube) : null;

  return (
    <img
      src={effectiveSrc || FALLBACK_THUMBNAIL}
      alt={title || '安飞供应链'}
      className={className}
      onError={() => setImgFailed(true)}
    />
  );
};

export default ContentThumbnail;
